import { getNavLink } from '../../../utils/nav';

import { Expandable, DownloadLinks } from './types';

export const CATEGORY_LINKS: Expandable[] = [
  {
    title: 'CATEGORIES',
    expanded: true,
    items: [
      { text: 'Text', href: getNavLink('/text') },
      { text: 'AI Writer', href: getNavLink('/text/ai-writer') },
      { text: 'Image', href: getNavLink('/image') },
      { text: 'Video', href: getNavLink('/video') },
      { text: 'Design', href: getNavLink('/design') },
      { text: 'Color', href: getNavLink('/color') },
      { text: 'Convert', href: getNavLink('/convert') },
      { text: 'PDF', href: getNavLink('/pdf') },
    ],
  },
  {
    title: 'ABOUT',
    items: [
      { text: 'About Us', href: getNavLink('/about') },
      { text: 'Blog', href: getNavLink('/blog') },
    ],
  },
  {
    title: 'PICSART',
    items: [
      { text: 'Picsart', href: 'https://picsart.com/' },
      { text: 'Photo Editor', href: 'https://picsart.com/photo-editor' },
      { text: 'Admaker', href: 'https://onlineadmaker.com' },
      { text: 'Text-to-Image', href: 'https://picsart.com/ai-image-generator' },
      { text: 'AI Editing', href: 'https://picsart.com/ai-photo-editing' },
      { text: 'AI Avatar', href: 'https://picsart.com/ai-avatar' },
      { text: 'Support', href: 'https://support.picsart.com/hc/en-us' },
      { text: 'Careers', href: 'https://picsart.com/jobs' },
      { text: 'API', href: 'https://picsart.io/' },
    ],
  },
];

export const TERMS_LINKS: Expandable = {
  title: 'LEGAL',
  items: [
    {
      href: 'https://picsart.com/terms-of-use',
      text: 'Terms of Use',
    },
    {
      href: 'https://picsart.com/privacy-policy',
      text: 'Privacy Policy',
    },
    {
      href: 'https://picsart.com/privacy-policy#interest-based',
      text: 'Interest-Based Advertising',
    },
  ],
};
export const STORE_LINKS: DownloadLinks[] = [
  {
    href: 'https://apps.apple.com/us/app/picsart-photo-studio/id587366035',
    imgSrc: 'https://cdn140.picsart.com/51903765248879042678.svg',
    width: 85,
    height: 28,
    target: '_blank',
    rel: 'noreferrer',
    analyticsActionType: 'app_store',
    alt: 'Apple App Store',
  },
  {
    href: 'https://play.google.com/store/apps/details?id=com.picsart.studio',
    imgSrc: 'https://cdn140.picsart.com/40576385706185324218.svg',
    width: 96,
    height: 28,
    target: '_blank',
    rel: 'noreferrer',
    analyticsActionType: 'google_play',
    alt: 'Google Play',
  },
  {
    href: 'https://apps.microsoft.com/store/detail/picsart-photo-editor/9WZDNCRFJ10M?hl=en-us&gl=US',
    imgSrc: 'https://cdn140.picsart.com/35721633543324436515.svg',
    width: 78,
    height: 28,
    target: '_blank',
    rel: 'noreferrer',
    analyticsActionType: 'microsoft',
    alt: 'Microsoft Store',
  },
];
